import {
  ProductSubscriptionStatusesEnum,
  SUBSCRIPTION_BILLING_ACCESSIBLE_STATUSES,
} from "dash-common";

type Status = ProductSubscriptionStatusesEnum | null | undefined;

const PAYMENT_NEEDS_UPDATE = [
  ProductSubscriptionStatusesEnum.PAST_DUE,
  ProductSubscriptionStatusesEnum.INCOMPLETE,
];

/**
 * Whether the account gets what its plan includes. A payment Stripe is still
 * retrying counts: after 7 days of retries Stripe cancels the subscription, and
 * until then the broker is still a customer.
 */
export const hasPaidAccess = (status: Status): boolean =>
  !!status && SUBSCRIPTION_BILLING_ACCESSIBLE_STATUSES.includes(status);

/** The last charge failed, or the first one has not gone through yet. */
export const needsPaymentUpdate = (status: Status): boolean =>
  !!status && PAYMENT_NEEDS_UPDATE.includes(status);
